/* eslint-disable react/destructuring-assignment */
import React, { useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Modal, themes, activateTheme } from '../../canvasComponents/index';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './messages';

function RemoveClaimPopUp(props) {
  useEffect(() => {
    activateTheme(themes.sonnet);
  }, []);

  const onCloseHandler = () => {
    props.closeRemovePopUp();
  };

  const onConfirmHandler = () => {
    props.confirmRemovePopUp();
    props.closeRemovePopUp();
  };

  return (
    <Modal
      ariaHideApp={false}
      id="remove_claim_modal"
      isOpen={props.open}
      onRequestClose={onCloseHandler}
    >
      <p className="pop-up-title">
        <FormattedMessage {...messages.removeClaim} />
      </p>
      <span className="pop-up-text-bigger">
        <FormattedMessage {...messages.areYouSure} />
      </span>
      <div className="several-buttons-wrapper">
        <Button
          primary
          className="pop-up-btn"
          onClick={() => onConfirmHandler()}
        >
          <FormattedMessage {...messages.yesRemove} />
        </Button>
        <Button
          className="black-underline-button center"
          onClick={() => onCloseHandler()}
        >
          <FormattedMessage {...messages.cancel} />
        </Button>
      </div>
    </Modal>
  );
}

export default injectIntl(RemoveClaimPopUp);
